function fixCarousel() {
    //var jcarouselSteps = $('.jcarousel').width() / 176;
    //$('.jcarousel-control-prev').jcarouselControl({
    //    target: '-=' + jcarouselSteps
    //});

    //$('.jcarousel-control-next').jcarouselControl({
    //    target: '+=' + jcarouselSteps
    //});
    /*$('.jcarousel').jcarousel({
        wrap: 'circular',
        animation: {
            duration: 1000,
            easing: 'linear',
        }
    });
    $('.jcarousel').jcarouselAutoscroll({
        interval: 2000
    });
    $('.jcarousel').hover(function () {
        $(this).jcarouselAutoscroll('stop');
    }, function () {
        $(this).jcarouselAutoscroll('start');
    });*/
}

function setColorbox() {
  $.colorbox.remove();
  var w = $("#site-main").width();
  var maxWidth = '100%';
  if (w > 1250) maxWidth = '1200px';
  
  console.info(maxWidth);
  
  /*$(document).on('cbox_open',function(){
    $(document.body).css('overflow','hidden');
  }).on('cbox_closed',function(){
    $(document.body).css('overflow','');
  });*/
  

  //$.colorbox.close = function(){return false;};
  /*var originalClose = $.colorbox.close;
  $.colorbox.close = function(){
  	//console.info($(e.target).attr('id'));
    //e.preventDefault();
    setTimeout(function() {
      if ($("#cboxClose").attr("data-open") == "true") {
      $("#cboxClose").removeAttr("data-open");
      //originalClose();
      }
    }, 100);
  };*/
   
  // Color Samples Button
  /*$("#button-color-samples").colorbox({href:"/pages/request-free-poly-color-samples",scalePhotos:true,width:maxWidth,initialWidth:'200px',initialHeight:'200px',overlayClose:true,escKey:false,trapFocus:true,transition:'none',onComplete:function() {
    //$("#cboxClose").on("click", function() { $(this).attr("data-open", "true"); alert("Really close this form?"); });
    //$("#site-main").remove();
  }});*/
  
  // Warranty Page Links
  /*$(".colorbox").each(function(index) {
    var url = $(this).attr("data-href");
    var close = $(this).attr("data-close-button");
    if (url.length > 0) {
      $(this).on('click', function(e) {
      	e.preventDefault();
      })
      $(this).colorbox({href:url,scalePhotos:true,width:maxWidth,initialWidth:'200px',initialHeight:'200px',closeButton:close == "false" ? false : true});
    }
  });*/
  
  // Large Images
  /*$(".product-galley--image-background").each(function(index) {
    var url = $(this).attr("data-image");
    var width = $(this).find("img").first().attr("data-rimg-max").split('x')[0];
    if (url.length > 0) {
      if (width < 1200) maxWidth = width + 'px';
      $(this).on('click', function(e) {
      	e.preventDefault();
      })
      $(this).colorbox({href:url,scalePhotos:true,width:maxWidth,initialWidth:'200px',initialHeight:'200px'});
    }
  });*/
}

function checkQuickShip () {
  //$(".product-form--atc-button").click(function(e) {
    $(".atc-banner--product .atc--product .qship").remove();
    $(".atc-banner--product .atc--product .pwship").remove();
    //if ($(this).hasClass("clicked") == false)
    //{
      var productvendor = $(".product-vendor a").attr("title").toLowerCase().replace(" ", "-");
	  var shipestimate = '';
      var polywoodnotice = '';
	  if (productvendor == "polywood")
	  {
        //polywoodnotice = '<div class="rte pwship" style="display:none"><p><strong>Important:</strong> If you order Quick-Ship items and Extended Shipping items from Polywood together, the whole order from this manufacturer will ship in an estimated 12-14 weeks. Please purchase all Quick-Ship items in a separate order to get those items faster.</p></div>';
        var colorselection = $('.form-field-select-wrapper label:contains("Color")').parent().find("select").val();
        var qscolors = quickcolors.split(/, | and /);
        var stock = 0;
        instockcolors.forEach(function (item, index) {
          console.log(item[0], item[1]);
          if (item[0] == colorselection) stock = item[1]
        });
        if (stock > 0) shipestimate = "1-3 business days"
		else if (colorselection.indexOf("Vintage") >= 0 || colorselection == "Kona" || colorselection == "Natural" || colorselection == "Driftwood") // Vintage
		{
		  if (estimatedShippingMinVintage == estimatedShippingMaxVintage) shipestimate = estimatedShippingMinVintage
		  else shipestimate = estimatedShippingMinVintage + " - " + estimatedShippingMaxVintage;
		}
        else if (qscolors.indexOf(colorselection) === -1) // Slow
        {
		  if (estimatedShippingMin == estimatedShippingMax) shipestimate = estimatedShippingMin
		  else shipestimate = estimatedShippingMin + " - " + estimatedShippingMax;

			//var maxWidth = '100%';
			//var w = $("#site-main").width();
			//if (w > 960) maxWidth = '900px';
			//$(this).addClass("clicked");
			//setTimeout(function() {
			//$(".clicked").colorbox({html:'<div style="padding:0px 25px 0px 25px" class="rte"><h3>Important</h3><p>Please note that if you order Quick-Ship items and Extended Shipping items from Polywood together, the whole order from this manufacturer will ship in an estimated 12 weeks so please purchase all Quick-Ship items together in a separate order to get those items fast!</p></div>',width:maxWidth,initialWidth:'200px',initialHeight:'200px'});
			  //console.info(productvendor);
			  /*$(".atc-banner--product .atc--product").append('<div class="rte pwship" style="display:none"><p><strong>Important:</strong> If you order Quick-Ship items and Extended Shipping items from Polywood together, the whole order from this manufacturer will ship in an estimated 12-14 weeks. Please purchase all Quick-Ship items in a separate order to get those items faster.</p></div>');
			  $(".atc-banner--product .atc--product .qship").slideDown();*/
			//}, 1250);
        }
		else // Quick
		{
          if (estimatedShippingMinQuick == estimatedShippingMaxQuick) shipestimate = estimatedShippingMinQuick
		  else shipestimate = estimatedShippingMinQuick + " - " + estimatedShippingMaxQuick;
		}
	  }
	  else shipestimate = estimatedShipping.length > 0 ? estimatedShipping : (estimatedShippingMin == estimatedShippingMax ? estimatedShippingMin : (estimatedShippingMin + " - " + estimatedShippingMax));
	  if (shipestimate.length > 3) // Longer than just " - ". It must have at least a full date.
	  {
	    setTimeout(function() {
		  $(".atc-banner--product .atc--product").append('<div class="rte qship" style="display:none"><p><strong>Estimated Ship Date:</strong><br />' + shipestimate +'</p></div>' + polywoodnotice);
	      $(".atc-banner--product .qship").slideDown();
          $(".atc-banner--product .pwship").slideDown();
          if ($(".button-complimentary").length > 0 && $(".atc-button--complimentary").length == 0) {
            $(".atc-banner--cart-footer").append('<a class="button-secondary atc-button--complimentary"><span>View Related Products</span></a>');
            $(".atc-button--complimentary").click(function () {
              $(".button-complimentary").trigger("click");
            });
          }
		}, 250);
	  }
    //}
    //else $(this).removeClass("cboxElement");
  //});
}

//$(window).on("resize", function () {
  //fixCarousel();
  //setColorbox();
//});

function arrayRemove(arr, value) { 
  return arr.filter(function(ele){ 
    return ele != value; 
  });
}

function getParameterByName(name, url = window.location.href) {
    name = name.replace(/[\[\]]/g, '\\$&');
    var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, ' '));
}

function updatePaymentsDiv()
{
    if ($("#smt-payment-terms").length > 0 && $("form > shopify-payment-terms").length > 0 )
    {
        var sr = $("form > shopify-payment-terms")[0].shadowRoot;
        var el = $(sr).find("shop-pay-installments-banner");
        $("#smt-payment-terms").append(el);
    }
}

function updateSwatch(producttitle, productvendor) {
  if (producttitle.indexOf("woven") === -1  && (productvendor === 'luxcraft' || productvendor === 'berlin-gardens' || productvendor === 'polywood' || productvendor === 'amish-yard'))
  {
    $(".dropdown-color select").each(function() {
      var colorselection = $(this).val();
      var swatchcolor = colorselection.toLowerCase().replace('\'','').replace(' / ', '-on-').replace('/', '-on-').replace(/ /g, '-').replace(/-[-–]-.+/g, ''); // Dash or em-dash in []
      var swatchType = "swatch";
      if (Boolean($(this).parent().siblings(".fabric-swatches").length)) swatchType = "swatch-fabric";
      else if (Boolean($(this).parent().siblings(".sling-swatches").length)) swatchType = "swatch-sling";
      
      console.info(swatchType + " " + swatchcolor);
      if (typeof swatchurl !== 'undefined') {
        if (producttitle.indexOf("berlin gardens murphy") >= 0 || producttitle.indexOf("berlin gardens vida") >= 0) swatchcolor += "-aluminum";
        var newswatchurl = swatchurl.replace('color.png', swatchType + "-" + productvendor + '-' + swatchcolor + '.png');
        console.info(newswatchurl);
        $(this).parent().parent().find("img").attr("src", newswatchurl);
      }
    });
  }
}

function checkInStock() {
  $(".dropdown-color select, .dropdown-regular select").on("change", function() {
    var productvendor = $(".product-vendor a").attr("title").toLowerCase().replace(" ", "-").replace("'", "");
    var producttitle = $(".product-title").text().toLowerCase().trim();
	var shipestimate = '';
    var shipestimateweeks = '';
    var colorselection = $(this).val();

    //const urlParams = new URLSearchParams(window.location.search);
    //const myParam = urlParams.get('go');

    if (producttitle.indexOf("woven") === -1 && (productvendor === 'luxcraft' || productvendor === 'berlin-gardens' || productvendor === 'polywood' || productvendor === 'amish-yard'))
    {
      //console.info($(".swatch-image").length);
      if ($(".swatch-image").length === 0)
      {
        var $e = $('<div class="swatch-image" style="display:inline-block;width:18%;height:50px;top:0;position:absolute;border-top:1px solid #cccccc;border-bottom:1px solid #cccccc;box-shadow: 0 1px 2px #00000026; padding-top:10px; text-align:center"><img src="" width="30" height="30" style="border:1px solid #eeeeee"></div>')
        $("a.swatches,a.fabric-swatches,a.sling-swatches").before($e).siblings(".dropdown-color").css("width", "64%");
        //$("a.swatches").before($e).siblings(".dropdown-color").css("width", "64%");
      }
    }
    
    if (1 == 1) //(productvendor == "polywood" || productvendor == "luxcraft")
	{
      /*if ($("#alertspan").length == 0) $(".product-sku").append("<span id='alertspan'>0</span>");
      else {
        var intalert = parseInt($("#alertspan").text());
        intalert++;
        $("#alertspan").text(intalert);
      }*/
      var qscolors = quickcolors.split(/, | and /);
      if (qscolors.indexOf(colorselection) === -1 && colorselection.indexOf("Vintage") === -1 && colorselection !== "Kona" && colorselection !== "Natural" && colorselection !== "Driftwood") // Slow
      {
	  	shipestimate = estimatedShippingMin + " - " + estimatedShippingMax;
        //shipestimateweeks = (Math.round(estimatedShippingWeeksMin) !== estimatedShippingWeeksMin ? estimatedShippingWeeksMin : Math.round(estimatedShippingWeeksMin)) + "-" + (Math.round(estimatedShippingWeeksMax) !== estimatedShippingWeeksMax ? estimatedShippingWeeksMax : Math.round(estimatedShippingWeeksMax));
        //shipestimate = estimatedShipping;  
        var shipMin = (Math.round(estimatedShippingWeeksMin) !== estimatedShippingWeeksMin ? estimatedShippingWeeksMin : Math.round(estimatedShippingWeeksMin));
        var shipMax = (Math.round(estimatedShippingWeeksMax) !== estimatedShippingWeeksMax ? estimatedShippingWeeksMax : Math.round(estimatedShippingWeeksMax));
        shipestimateweeks = (shipMin == shipMax ? shipMin : shipMin + "-" + shipMax);
      }
      else if(colorselection.indexOf("Vintage") >= 0 || colorselection == "Kona" || colorselection == "Natural" || colorselection == "Driftwood")
      {
        shipestimate = estimatedShipping;  
        var shipMin = (Math.round(estimatedShippingWeeksMinVintage) !== estimatedShippingWeeksMinVintage ? estimatedShippingWeeksMinVintage : Math.round(estimatedShippingWeeksMinVintage));
        var shipMax = (Math.round(estimatedShippingWeeksMaxVintage) !== estimatedShippingWeeksMaxVintage ? estimatedShippingWeeksMaxVintage : Math.round(estimatedShippingWeeksMaxVintage));
        shipestimateweeks = (shipMin == shipMax ? shipMin : shipMin + "-" + shipMax);
      }
	  else // Quick
	  {
        shipestimate = estimatedShipping;
        var shipMin = (Math.round(estimatedShippingWeeksMinQuick) !== estimatedShippingWeeksMinQuick ? estimatedShippingWeeksMinQuick : Math.round(estimatedShippingWeeksMinQuick));
        var shipMax = (Math.round(estimatedShippingWeeksMaxQuick) !== estimatedShippingWeeksMaxQuick ? estimatedShippingWeeksMaxQuick : Math.round(estimatedShippingWeeksMaxQuick));
        shipestimateweeks = (shipMin == shipMax ? shipMin : shipMin + "-" + shipMax);
	  }
      var stock = 0;
      var stockcolorsarr = [];
      instockcolors.forEach(function (item, index) {
        console.log(item[0], item[1]);
        if (item[0] == colorselection) stock = item[1];
        stockcolorsarr.push(item[0]);
        qscolors = arrayRemove(qscolors, item[0]);
      });
      console.info(stockcolorsarr.length);
      var stockcolors = stockcolorsarr.length > 0 ? ". <strong>" + stockcolorsarr.join(', ').replace(/,(?=[^,]*$)/, ' and') + (stockcolorsarr.length > 1 ? " are in stock and ship" : " is in stock and ships") + " in just 5 business days</strong>" : "";
      //$sd = $('<strong class="ship-details"></strong>').append($(".ship-details a"));
      $(".ship-details").remove();
      if (stock > 0) {
        var onlystock = " Many available and ready to ship.";
        if (stock < 30) onlystock = " <span style='color:red'>Just " + stock + " available</span>"
        $(".ship-estimate").html("<strong>This color is in stock.</strong> Ships in just <strong>1-3</strong> business days. <strong>Order now!" + onlystock + "</strong>.");
        //$sd.appendTo(".ship-estimate").hide();
      }
      else {
        if (qscolors.indexOf(colorselection) === -1 && colorselection.indexOf("Vintage") === -1 && colorselection !== "Kona" && colorselection !== "Natural" && colorselection !== "Driftwood") { // Slow
       	  //if (quickcolors.length > 0) $(".ship-estimate").html("<strong>Get free " + shipestimateweeks + " week shipping when you order from these colors:</strong> " + qscolors.join(', ').replace(/,(?=[^,]*$)/, ' and') + stockcolors + ". Shipping on other colors may take a little longer.");
          //else $(".ship-estimate").html("<strong>Shipping times are extended.</strong>");
          //if (quickcolors.length > 0) $(".ship-estimate").html("<strong>FREE Quick Shipping!</strong>&nbsp&nbspEstimate: " + shipestimateweeks + (shipestimateweeks.indexOf('-') > -1 || estimatedShippingMax > 1 ? " weeks" : "week") + ".</strong>");
          //else $(".ship-estimate").html("<strong>FREE Shipping!</strong> Estimate: " + shipestimateweeks + (shipestimateweeks.indexOf('-') > -1 || estimatedShippingMax > 1 ? " weeks" : " week") + ".</strong>");
          if (producttitle !== "gift card") {
            $(".ship-estimate").html("<strong>FREE Shipping!</strong> Estimate: " + shipestimateweeks + ((shipestimateweeks + "").indexOf('-') > -1 || parseInt(shipestimateweeks) > 1 ? " weeks" : " week") + ".</strong>");
          }
          console.info("SLOW");
        }
        else if (colorselection.indexOf("Vintage") >= 0 || colorselection == "Kona" || colorselection == "Natural" || colorselection == "Driftwood") { // Vintage
          $(".ship-estimate").html("<strong>FREE Shipping!</strong> Estimate: " + shipestimateweeks + ((shipestimateweeks + "").indexOf('-') > -1 || parseInt(shipestimateweeks) > 1 ? " weeks" : " week") + ".</strong>");
          console.info("VINTAGE");
        }
        else // Quick
        {
          //$(".ship-estimate").html("<strong>Get free " + shipestimateweeks + " week shipping when you order this color" + stockcolors + ".</strong> Shipping on other colors may be extended.");
          $(".ship-estimate").html("<strong>FREE Quick Shipping!</strong>&nbsp&nbspEstimate: " + shipestimateweeks + ((shipestimateweeks + "").indexOf('-') > -1 || parseInt(shipestimateweeks) > 1 ? " weeks" : " week") + ".</strong>");
        }
        //$(".ship-estimate").html("<strong>Get free " + shipestimateweeks + " week shipping when you order this color" + stockcolors + ".</strong> Shipping on other colors may be extended.");
        //$(".ship-estimate").html("<strong>Estimated Ship Date:</strong><br />" + shipestimate);
        //$sd.appendTo(".ship-estimate").before(" (").after(")").show();
      }
      console.info(shipestimate + " " + shipestimateweeks);
      console.info(colorselection);
      updateSwatch(producttitle, productvendor);
    }
    //console.info(colorselection + " " + "<strong>This color is in stock. Order now!</strong> Just " + stock + " available.</p><p>Ships in just 5 business days.");
    //updatePaymentsDiv();
  });
  var qvariant = getParameterByName('variant');
  //console.info(qvariant);
  /*if (qvariant != null || instockcolors === undefined || instockcolors.length == 0) $(".dropdown-color select").trigger("change");
  else {
  	console.info(instockcolors[0][0]);
    //$(".dropdown-color select").val(instockcolors[0][0]);
    //$(".dropdown-color select").trigger("change")
    //$("select.form-options").trigger("change")
  }*/
  $(".dropdown-color select, .dropdown-regular select").trigger("change").trigger("blur");
}

function disableSitePrepGuide() {
  if(window.location.hash) {
    if (window.location.hash === "#judgeme") {
      $("._form-wrapper").remove();
      $("#someone-purchased").remove();
    }
  } else {
   console.info("no hash")
  }
}

function initComplimentary() {
  if (typeof(complimentary) !== 'undefined') {
    if (complimentary.length > 0) {
      var $complimentary = $("<div id='ulComplimentary'></ul>");
      var $complimentaryUl = $("<ul></ul>");
      for (var i = 0; i < complimentary.length; i++) {
        $complimentaryUl.append("<li class=''><div class=''>" +
                              "<a class='comp-image-link' href='/products/" + complimentary[i][1] + "'><img data-src='/cdn/shop/" + complimentary[i][2].replace(/\.(?=[^.]*$)/, "_500x500.") + "' alt='" + complimentary[i][0] + "' /></a>" +
                              "<div class=''>" +
                              "<h2 class=''><a class='' href='/products/" + complimentary[i][1] + "'>" + complimentary[i][0] + "</a></h2></div></div></li>");
      }
      $complimentary.append($complimentaryUl);
      var $btnComplimentary = $('<div class="button-complimentary button-secondary full-width">View Related Products</div>');
      $(".product-shipping-time").after($btnComplimentary);
      
      new jBox('Modal', {
        attach: '.button-complimentary',
        title: '<strong>Related Products...</strong>',
        content: $complimentary,
        onOpen: function() { 
          $("#ulComplimentary img[data-src]").each(function(e) {
            $(this).attr("src", $(this).attr("data-src")).removeAttr("data-src");
          });
        }
      });
    }
  }
}

$(document).ready(function () {
  //console.info("HERE");  
  //console.info("jquery version = "+ $.fn.jquery);
  
  /*var modalSamples = new jBox('Modal', {
    attach: "#button-color-samples",
    ajax: {
      url: '/pages/request-free-poly-color-samples',
      reload: 'strict',
      setContent: false,
      success: function (response) {
        this.setContent(response);
      },
      error: function () {
        this.setContent('<b style="color: #d33">Error loading content.</b>');
      }
    }
  });*/

  // Hide and Unselect Allochrome Brackets
  var $allochrome = $('.form-field-select-wrapper label:contains("Allochrome")');
  //console.info("Allochrome: " + $allochrome.length);
  if ($allochrome.length > 0) {
    /*console.info("Allochrome: " + $allochrome.siblings("select").first().val());
    $allochrome.siblings("select").first().val("No").prop("selected",true).trigger("change");
    console.info("Allochrome: " + $allochrome.siblings("select").first().val());*/
    $allochrome.parent().hide().append('<div class="product-shipping-time allochrome">Add these if you live by the beach</div>');
  }
  
  // jBox
  $(".jbox").each(function(index) {
    var url = $(this).attr("data-href");
    var dataclass = $(this).attr("data-class");
    if (url.length > 0) {
      new jBox('Modal', {
        attach: ".jbox." + dataclass,
        preventDefault: true,
        onClose: function () {
          if ($(".jdgm-widget-actions-wrapper").length > 1) $(".jdgm-widget-actions-wrapper").first().remove();
        },
        ajax: {
          url: url,
          setContent: false,
          animation: 'zoomIn',
          success: function (response) {
            var w = $("#site-main").width();
  			var maxWidth = '100%';
  			if (w > 1250) maxWidth = '1200px';
            this.setContent(response);
            this.setWidth(maxWidth);
          },
          error: function () {
            this.setContent('<b style="color: #d33">Error loading content.</b>');
          }
        }
      });
    }
  });
  
  var largeImage = new jBox('Image', {src: "data-image"});
  
  /*$(".product-galley--image-background").on('click', function(e) {
    e.preventDefault();
    console.info($(this).attr("data-image"));
    //largeImage = new jBox('Image', {src: $(this).attr("data-image")});
    //largeImage.open();
  });*/
  
  //setColorbox();
  //checkQuickShip();
  
  // Check if header has changed
  var target = document.querySelector(".site-header");
  var observer = new MutationObserver(function(mutations) {
    if($("header > section.atc-banner--container").length > 0);
    checkQuickShip();
  });
  var config = { attributes: false, childList: true, characterData: false };
  observer.observe(target, config);
  
  
  $('.form-field-select-wrapper label:contains("Frame Extension")').parent().append('<div class="product-shipping-time">Add the frame extension for use with Counter and Bar Height Double Pedestal Tables</div>');
  
  if (typeof asseturl !== 'undefined') {
    //console.info(asseturl);  
    
    $('.form-field-select-wrapper label:contains("Allochrome")').parent().append('<div class="product-shipping-time allochrome">Add these if you live by the beach</div>');
    
    var productvendor = $(".product-vendor a").attr("title").toLowerCase().replace(" ", "-");
    //console.info(productvendor);
    var queryid = asseturl.split('?')[1];
    asseturl = asseturl.split('?')[0].replace('color.png', '');
    var reversed = variantoptions.reverse().slice(0);
    variantoptions.reverse();
    var $hammeredswatches = $('<span>');
    var $hammeredoptions = $('<span>');
    var hammeredoptionindex = -1;
    //var allvariants = [];
    variantoptions.forEach(function (v) {
      var choiceparts = v.split('\\');
      var choiceoptions = choiceparts[0].split('|');
      for (var i = 0; i < choiceoptions.length; i++)
      {
        var $s = $("#data-product-option-" + i);
        var options = choiceoptions[i].split('~');
        options.forEach(function (o) {
          //console.info("Option:" + o);
          var $o = $("<option>").val(o).text(o);
          if ($s.attr("data-values") === undefined || $s.attr("data-values").split('|').indexOf(o) == -1) {
            if (o.indexOf("Hammered ") == 0) { //indexOf is zero-based
              $hammeredoptions.append($o);
              hammeredoptionindex = i;
            }
            else if ($('label[for="data-product-option-' + i + '"]').text().trim().toLowerCase().indexOf("allochrome") > 0 && o == "Yes") {
              $(".allochrome").closest(".form-field").hide()
              //$o.prop("disabled", true);
            }
            else $s.append($o);
            var datavalues = $s.attr("data-values");
            if (datavalues === undefined) {
              var $p = $s.parent().parent();
              $s.attr("data-values", o)
              if ($p.hasClass("finish") == false) {
                $("<div>").addClass("swatch").addClass("clearfix").attr("data-option-index", i).attr("style", "clear: both").insertAfter($p);
              }
            }
            else $s.attr("data-values", $s.attr("data-values") + "|" + o);
            if ($('label[for="data-product-option-' + i + '"]').text().trim().toLowerCase().indexOf('color') > 0)
            {
              var swatchcolor = o.toLowerCase().replace('\'','').replace(' / ', '-on-').replace('/', '-on-').replace(/ /g, '-').replace(/-[-–]-.+/g, ''); // Dash or em-dash in []
              console.info(swatchcolor);
              if (swatchcolor.length > 0)
              {
                var $swatchcontainer = $('div[data-option-index=' + i + ']');
                var $swatch = $("<div>").attr("data-value", o).addClass("swatch-element").addClass("color").addClass("available").addClass(swatchcolor);
                if (swatchcolor.indexOf("hammered") == 0) { //indexOf is zero-based
                  $swatch.appendTo($hammeredswatches);
                }
                else $swatch.appendTo($swatchcontainer);
                $("<label>").attr("style", "background-color: " + swatchcolor + "; background-position: center -8px; background-image: url(" + asseturl + "swatch-" + productvendor + "-" + swatchcolor + ".png?" + queryid + ")").appendTo($swatch);
                $("<div>").addClass("tooltip").text(o).appendTo($swatch);
              }
            }
          }
        });
      }
      //allvariants.push(v);
    });
    //console.info(v);
    //Put the Hammered Options last
    if (hammeredoptionindex >= 0) {
      $hammeredswatches.children().appendTo($('div[data-option-index=' + hammeredoptionindex + ']'));
      $("#data-product-option-" + hammeredoptionindex).append($hammeredoptions.children());
    }
    $(".swatch-element label").on("click", function() {
      var i = $(this).closest(".swatch").attr("data-option-index");
      $("#data-product-option-" + i).val($(this).closest(".swatch-element").attr("data-value"));
      updatePrice();
    });
    $(".no-variant-limit-select").on('change blur', function() {
      updatePrice();
    });
    
    //console.info(reversed);

    //var allArrays = [];
    //$(".no-variant-limit-select").each(function () {
    //	allArrays.push($(this).attr("data-values").split('|'));
    //});

    function updatePrice()
    {
      var $hammeredselect = $('select[data-values="Standard|Hammered"]');
      if ($hammeredselect.length > 0) {
        if($('select[name="properties[Main Color]"]').val().indexOf("Hammered") == 0) $hammeredselect.val("Hammered");
        else $hammeredselect.val("Standard");
      }
      //$(".shopify-payment-button").html("");
      var currentselections = [];
      var bestselection = "||";
      var bestmatch = '';
      //var choicevariant = $("input[name=id]").val();
      $(".no-variant-limit-select").each(function () {
        var i = $(this).attr("id").replace("data-product-option-", "");
        $('.swatch[data-option-index="' + i + '"] .swatch-element').removeClass("selected");
        $('.swatch[data-option-index="' + i + '"] .swatch-element[data-value="' + $(this).val() + '"]').addClass("selected");
        currentselections.push($(this).val());
      });

      var selectedstring = currentselections.join('|');

      reversed.forEach(function (v) {
        var tieroptions = [];
        var choiceparts = v.split('\\');
        var choiceoptions = choiceparts[0].split('|');
        var choicevariants = choiceparts[1].split('|');
        var choiceprice = choicevariants[0];
        var choicecompareprice = choicevariants[1];
        var choicevariant = choicevariants[2];
        var variantprice = choiceprice + "|" + choicecompareprice + "|" + choicevariant;
        
        //console.info(variantprice);

        choiceoptions.forEach(function (t) {
          tieroptions.push(t.split('~'));
          //console.info(t);
        });

        
        //console.info("S:" + selectedstring);
        //console.info("T:" + tieroptions);
        allPossibleCases(tieroptions).forEach(function (t) {
          //console.info(t);
          if (selectedstring == t) {
            //console.info("Match");
            bestselection = variantprice;
            bestmatch = variantprice;
            //console.info(bestselection);
          }
          else {
            //console.info("No Match");
            var intersection = [];
            intersection.push(currentselections);
            intersection.push(t.split('|'));
            var matching = intersection.reduce((a, b) => a.filter(c => b.includes(c)));
            var thismatch = variantprice + "~" + matching.length;
            if (bestmatch.length == 0) {
              //$(".shopify-payment-button").append(matching + "<br />");
              bestmatch = thismatch;
              bestselection = variantprice;
            }
            else {
              var bestmatchparts = bestmatch.split('~');
              var matches = parseInt(bestmatchparts[1]);
              if (matching.length > matches)
              {
                var matchprices = bestmatchparts[0].split('|');
                var matchprice = matchprices[0];
                var matchcompareat = matchprices[1];
                var matchvariant = matchprices[2];
                bestselection = variantprice;
                bestmatch = thismatch;
                //bestselection = matchprice + "|" + matchcompareat + "|" + matchvariant;
              }
            }
            //$(".shopify-payment-button").append(matching + "<br />");
          }
        });
        //$(".shopify-payment-button").append(bestselection + "<br />");
      });
      //$(".shopify-payment-button").append(bestselection + "<br />");

      
      //console.info("B:" + bestselection);
      var itemprice = bestselection.split('|');
      var price = itemprice[0];
      var compare_at_price = itemprice[1];
      var variant = itemprice[2];
      var $details = $("[data-product-details]");

      $details.find('[data-price]').text("$" + (price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
      //alert(price);
      if (compare_at_price.length > 0) 
      {
        $details.find('[data-price-compare-at]').addClass("visible");
        $details.find('[data-price-compare-at] .money').text("$" + (compare_at_price / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,'));
        $details.find('[data-price-percent-saved]').text(Math.round((1 - parseFloat(price) / parseFloat(compare_at_price)) * 100));
        $details.find('[data-badge-sales]').show();
      }
      else 
      {
        $details.find('[data-price-compare-at]').removeClass("visible");
        $details.find('[data-badge-sales]').hide();
      }
      $("input[name=id]").val(variant);
      $("select[name=id]").val(variant);

      // Update product SKU
      var $variant_option = $("option[data-variant-id='" + variant + "']");
      if ($variant_option.length === 1) $("[data-product-sku]").text($variant_option.attr("data-sku"));
      //$(".shopify-payment-button").append("options: " + allPossibleCases(tieroptions) + "<br />price: " + choiceprice + "<br />variant: " + choicevariant + "<br />");
      console.info("Update Price");
    }

    function allPossibleCases(arr) {
      if (arr.length == 1) {
        return arr[0];
      } else {
        var result = [];
        var allCasesOfRest = allPossibleCases(arr.slice(1));  // recur with the rest of array
        for (var i = 0; i < allCasesOfRest.length; i++) {
          for (var j = 0; j < arr[0].length; j++) {
            result.push(arr[0][j] + '|' + allCasesOfRest[i]);
          }
        }
        return result;
      }
    }


    /*
      function updatePrice()
      {
        var price = 0;
        var compare_at_price = 0;
        var variant_id = "";
        $(".no-variant-limit-select").each(function() {
          var this_price = $('option:selected', this).attr("data-variant-price");
          var this_compare_at_price = $('option:selected', this).attr("data-variant-compare-at-price");
          var this_variant_id = $('option:selected', this).attr("data-variant-id");
          if (parseInt(this_price) > parseInt(price)) {
            price = this_price;
            compare_at_price = this_compare_at_price;
            variant_id = this_variant_id;
          }
          //console.info(price);
          //console.info(compare_at_price);
        });
        var $details = $("[data-product-details]");
        if (compare_at_price.length > 0) 
        {
          $details.find('[data-price]').text(Math.round(parseInt(price.replace(",", "")) * 100 / parseInt(compare_at_price.replace(",", "") )));
          $details.find('[data-price-compare-at]').addClass("visible");
          $details.find('[data-price-compare-at] .money').text("$" + compare_at_price);
          $details.find('[data-price-percent-saved]').text(Math.round(parseInt(price.replace(",", "")) * 100 / parseInt(compare_at_price.replace(",", "") )));
          $details.find('[data-badge-sales]').show();
        }
        else 
        {
          $details.find('[data-price]').text("$" + (price / 100).toFixed(2));
          $details.find('[data-price-compare-at]').removeClass("visible");
          $details.find('[data-badge-sales]').hide();
        }
        $("input[name=id]").val(variant_id);
      }*/
    updatePrice();
  }
  
      
  // Update dropdown selection when the image variant is picked
  $(".product-gallery--thumbnail-trigger").on("click", function() {
    var selected_option = $(this).attr("data-product-option");
    if (selected_option.length > 0) {
      var color_options = 0
      var color_selects = [];
      $(".form-options label.form-field-title").each(function() {
        var dropdown_id = $(this).siblings("select").first().attr("id");
        if ($(this).text().toLowerCase().indexOf("color") !== -1) {
          color_options++;
          color_selects.push(dropdown_id);
        }
        else {
          // Remove the values that are not colors
          var colors_only = selected_option.split(/ \/ /);
          $("#" + dropdown_id + " option").each(function() {
            for (var i in colors_only) {
              //console.info($(this).text().trim() + " " + colors_only[i] + " " + colors_only.length);
              if(colors_only[i] == $(this).text().trim()) {
                colors_only.splice(i,1);
                break;
              }
            }
          });
          selected_option = colors_only.join(" / ");
        }
      });
      //console.info($(this).attr("data-product-option") + " " + $(".form-options .form-field-select").length + " " + color_options + " " + color_selects.length + " " + selected_option);
      if (color_options == 1) {
        //console.info(color_selects[0]);
        $("#" + color_selects[0] + " option").each(function() {
          if ($(this).val() == selected_option) $(this).prop("selected", true).parent().trigger("change").trigger("blur");
        });
      }
      else {
        var colors_only = selected_option.split("/");
        for (var i in color_selects) {
          $("#" + color_selects[i] + " option").each(function() {
            if ($(this).val() == colors_only[i].trim()) $(this).prop("selected", true);
          });
        }
         $("#" + color_selects[i]).first().trigger("change").trigger("blur");
      }
    }
  });
  
  // Update color dropdowns to include swatch lightboxes
  /*$(".form-options label.form-field-title").each(function() {
    var dropdown_id = $(this).siblings("select").first().attr("id");
    if ($(this).text().toLowerCase().indexOf("color") !== -1) {
      $(this).siblings("select").first().addClass("dropdown-color");
    }
  });*/
  
  $(".jdgm-rev-widg__title").before($(".share-buttons"));
  //$(".share-buttons").hide();
  
  checkInStock();
  updatePaymentsDiv();
  disableSitePrepGuide();
  initComplimentary();
});

// Sheds Metafield pricing
if ($(".js-pricing").length > 0) $(".js-pricing").parent().hide();

// Prebuilt Sheds table
if (typeof(pbvalues) !== 'undefined') {
  for (var i = 0; i < pbvalues.length; i++) {
    var arr_vals = pbvalues[i];
    var size_val = arr_vals[arr_vals.length - 1];
    arr_vals.pop();
    var cells = "<tr><td><b>" + size_val + "</b></td><td>$" + arr_vals.join("</td><td>$") + "</td></tr>";
    $('.table-prebuilt table tr:last').after(cells);
  }
}

// Onsite Sheds table
if (typeof(osvalues) !== 'undefined') {
  var addons = $('.table-add-ons').length > 0 ? true : false;
  console.info ("addons: " + addons);
  for (var i = 0; i < osvalues.length; i++) {
    var arr_vals = osvalues[i];
    var size_val = arr_vals[arr_vals.length - 1];
    arr_vals.pop();
    if (addons && typeof(ltvalues) !== 'undefined') {
      /*var arr_vals_addon = arr_vals.slice(0, 4).reverse();
      arr_vals = arr_vals.slice(4, 11);
      var addoncells = "<tr><td><b>" + size_val + "</b></td><td>$" + arr_vals_addon.join("</td><td>$") + "</td></tr>";
      $('.table-add-ons table tr:last').after(addoncells);*/
      var arr_vals_addon = ltvalues[i].reverse();
      var addoncells = "<tr><td><b>" + size_val + "</b></td><td>$" + arr_vals_addon.join("</td><td>$") + "</td></tr>";
       $('.table-add-ons table tr:last').after(addoncells);
    }
    var cells = "<tr><td><b>" + size_val + "</b></td><td>$" + arr_vals.join("</td><td>$") + "</td></tr>";
    $('.table-onsite table tr:last').after(cells);
  }
}

// Berlin Gardens Structures Metafield pricing
// if ($(".js-pricing").length > 0) $(".js-pricing").parent().hide();

var bgsizes = [];

// Prebuilt Structures table
if (typeof(bgpbvalues) !== 'undefined' || typeof(bggzvalues) !== 'undefined') {
  function formatValues(arr_vals) {
    return arr_vals.map(item => parseFloat(item).toLocaleString('en-US', {
      minimumFractionDigits: item.includes('.') ? 2 : 0,
      maximumFractionDigits: item.includes('.') ? 2 : 0
    }));
  }

  function createRow(size_val, arr_vals, posts_val = '', nanVal = "N/A") {
    let cells = `<tr><td><b>${size_val}</b></td>${posts_val ? `<td>${posts_val}</td>` : ''}<td>$${arr_vals.join("</td><td>$")}</td></tr>`;
    return cells.replace(/\$NaN/g, nanVal);
  }

  function getValuesFromColumns(arr_vals, columns) {
    // Ensure columns is treated as a string
    columns = String(columns);
  
    let indexes;
    if (columns.includes(',')) {
      indexes = columns.split(',').map(Number);
    } else {
      indexes = [Number(columns)];
    }
    /*console.info(columns);
    console.info(indexes);
    console.info(arr_vals);*/
    return formatValues(indexes.map(index => arr_vals[index]));
  }


  // Pavilion Pricing
  if (typeof(bgpbvalues) !== 'undefined') {
    console.info("Pavilion: " + bgpbvalues.length);
    bgpbvalues.forEach(arr_vals => {
        let size_val = arr_vals[0].replace(/~/g, "'");
        let posts_val = arr_vals[1];
        bgsizes.push(size_val);
        
        // Initialize variables as empty arrays
        let valuesone = [];
        let valuestwo = [];
    
        // First table logic
        let columnsOne = $('.table-bgpb-step1').data('columns');
        if (columnsOne) {
            valuesone = getValuesFromColumns(arr_vals, columnsOne);
        }
  
        // Second table logic
        let columnsTwo = $('.table-bgpb-step2').data('columns');
        if (columnsTwo) {
            valuestwo = getValuesFromColumns(arr_vals, columnsTwo);
        }
        
        $('.table-bgpb-step1 table tr:last').after(createRow(size_val, valuesone, posts_val).replace("$-", "-$"));
        $('.table-bgpb-step2 table tr:last').after(createRow(size_val, valuestwo).replace("$-", "-$"));
    });
  }
  
  // Gazebo Pricing
  if (typeof(bggzvalues) !== 'undefined') {
      bggzvalues.forEach(arr_vals => {
        let size_val = arr_vals[0].replace("~x", "' x").replace(/~/g, "'").trim();
        bgsizes.push(size_val.replace("Octagon", "").replace("Oblong", "").replace("Rectangle", ""));
        
        // Initialize variables as empty arrays
        let valuesStandard = [];
        let valuesRoof = [];
        let valuesScreen = [];
    
        // Standard table logic
        let columnsStandard = $('.table-bggz-standard').data('columns');
        if (columnsStandard) {
            valuesStandard = getValuesFromColumns(arr_vals, columnsStandard);
        }
  
        // Roof table logic
        let columnsRoof = $('.table-bggz-roof').data('columns');
        if (columnsRoof) {
            valuesRoof = getValuesFromColumns(arr_vals, columnsRoof);
        }
  
        // Screen table logic
        let columnsScreen = $('.table-bggz-screen').data('columns');
        if (columnsScreen) {
            valuesScreen = getValuesFromColumns(arr_vals, columnsScreen);
        }
        
        $('.table-bggz-standard table tr:last').after(createRow(size_val, valuesStandard, "", "Standard").replace("$-", "-$"));
        $('.table-bggz-roof table tr:last').after(createRow(size_val, valuesRoof, "", "Standard").replace("$-", "-$"));
        $('.table-bggz-screen table tr:last').after(createRow(size_val, valuesScreen, "", "Standard").replace("$-", "-$"));
    });
  }
}

// Built on Site table (Pergola)
if (typeof(bgbosvalues) !== 'undefined') {
  console.info("Sizes:" + bgsizes);
  var isalcove = $("title").text().includes("Alcove");
  for (var i = 0; i < bgbosvalues.length; i++) {
    var arr_vals = bgbosvalues[i];
    var size_val = arr_vals[0].replace("~x", "' x").replace(/~/g, "'").replace("Octagon", "").replace("Oblong", "").replace("Rectangle", "").replace("Square", "").trim();
    console.info(i + ' ' + bgsizes.length + ' ' + size_val);
    if (bgsizes.includes(size_val))
    {
      let columnsBos = $('.table-bgbos').data('columns');
      if (columnsBos) {
        let indexes = columnsBos.split(',').map(Number);
        console.info(arr_vals + " " + columnsBos);
        //console.info(getValuesFromColumns(arr_vals, columnsBos));
        arr_vals = indexes.map(index => arr_vals[index])
        console.info(arr_vals + " " + columnsBos);
      }
      else arr_vals = arr_vals.slice(1, 5);
      arr_vals.forEach(function(item, index, arr) {
        console.info("Item:" + item);
        if (typeof(item) !== 'undefined') arr[index] = parseFloat(item).toLocaleString('en-US', {
          minimumFractionDigits: item.includes('.') ? 2 : 0, maximumFractionDigits: item.includes('.') ? 2 : 0 
        }); 
      });
      var cells = "<tr><td><b>" + size_val + "</b></td><td>$" + arr_vals.join("</td><td>$") + "</td></tr>";
      $('.table-bgbos table tr:last').after(cells);
    }
    else if (isalcove && size_val == "Alcove")
    {
      arr_vals = arr_vals.slice(1, 3);
      arr_vals.push("315");
      for (var j = 0; j < bgsizes.length; j++) {
        console.info(arr_vals);
        var cells = "<tr><td><b>" + bgsizes[j] + "</b></td><td>$" + arr_vals.join("</td><td>$") + "</td></tr>";
        $('.table-bgbos table tr:last').after(cells);        
      }
    }
  }
}

